// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rI5r","toggleWrap":"styles_toggleWrap__3UXzv","content":"styles_content__3M0xK","selectAreaCode":"styles_selectAreaCode__qSXZx"};